// Thermal Resistance units with conversion factors to kelvin per watt (K/W)
export const thermalResistanceUnits = [
  { id: 'kelvin-per-watt', name: 'Kelvin/Watt', symbol: 'K/W', plural: 'Kelvins/Watt', factor: 1 },
  { id: 'degree-celsius-per-watt', name: 'Degree Celsius/Watt', symbol: '°C/W', plural: 'Degrees Celsius/Watt', factor: 1 },
  { id: 'degree-fahrenheit-hour-per-btu', name: 'Degree Fahrenheit Hour/BTU', symbol: '°F·h/BTU', plural: 'Degrees Fahrenheit Hour/BTU', factor: 1.8956342406 },
  { id: 'degree-fahrenheit-second-per-btu', name: 'Degree Fahrenheit Second/BTU', symbol: '°F·s/BTU', plural: 'Degrees Fahrenheit Second/BTU', factor: 0.0005265651 },
  { id: 'kelvin-second-per-joule', name: 'Kelvin Second/Joule', symbol: 'K·s/J', plural: 'Kelvins Second/Joule', factor: 1 },
  { id: 'degree-celsius-second-per-joule', name: 'Degree Celsius Second/Joule', symbol: '°C·s/J', plural: 'Degrees Celsius Second/Joule', factor: 1 },
];

export const popularThermalResistanceConversions = [
  { from: 'kelvin-per-watt', to: 'degree-celsius-per-watt' },
  { from: 'degree-celsius-per-watt', to: 'kelvin-per-watt' },
  { from: 'kelvin-per-watt', to: 'degree-fahrenheit-hour-per-btu' },
  { from: 'degree-fahrenheit-hour-per-btu', to: 'kelvin-per-watt' },
  { from: 'kelvin-per-watt', to: 'kelvin-second-per-joule' },
  { from: 'degree-celsius-per-watt', to: 'degree-fahrenheit-hour-per-btu' },
];

export const getUnitById = (id) => thermalResistanceUnits.find(unit => unit.id === id);

export const convertThermalResistance = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert thermal resistance units and learn the conversion formula.`;
};
